import { render, staticRenderFns } from "./TicketsChange.vue?vue&type=template&id=a709345e&"
import script from "./TicketsChange.vue?vue&type=script&lang=js&"
export * from "./TicketsChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports